import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang

export default {
    ...elementEnLocale,
    "login": {
        "accountPlaceholder": "Please input username",
        "backSignIn": "Back sign in",
        "confirmPassword": "Confirm Password",
        "diffPwd": "The two passwords are inconsistent",
        "email": "Email",
        "forgetFormTitle": "Reset password",
        "forgetPassword": "Forget Password?",
        "loginButton": "Sign in",
        "loginSuccessDesc": "Welcome back",
        "loginSuccessTitle": "Login successful",
        "mobile": "Mobile",
        'ChangeOne': 'Change One',
        "mobilePlaceholder": "Please input mobile",
        "mobileCompanyname": "Please input Companyname",
        "mobileUsername": "Please input Username",
        "mobileSignInFormTitle": "Mobile sign in",
        "otherSignIn": "Sign in with",
        "password": "Password",
        "passwordPlaceholder": "Please input password",
        "policy": "I agree to the xxx Privacy Policy",
        "policyPlaceholder": "Register after checking",
        "qrSignInFormTitle": "Qr code sign in",
        "registerButton": "Sign up",
        "rememberMe": "Remember me",
        "scanSign": "scanning the code to complete the login",
        "signInDesc": "Enter your personal details and get started!",
        "signInFormTitle": "Sign in",
        "signInTitle": "Backstage management system",
        "signUpFormTitle": "Sign up",
        "smsCode": "SMS code",
        "smsPlaceholder": "Please input sms code",
        "ssoEditDesc": "edit your personal details and get started！",
        "ssoInfoDesc": "get your personal details and get started!",
        "ssoSignInFormTitle": "sso login",
        "tenantName": "TenantName",
        "userName": "Username",
        "serviceHotline": 'serviceHotline',
        "manual": 'Downloadthemanual',

    },
    "info": {
        "basicInfo": "Basic Information",
        "resetPwd": "Reset Password",
        "title": "Basic Information",
        "userSocial": "Social Information"
    },
    "password": {
        "cfPwdMsg": "Please Enter Confirm Password",
        "confirmPassword": "Confirm Password",
        "diffPwd": "The Passwords Entered Twice No Match",
        "newPassword": "New Password",
        "newPwdMsg": "Please Enter New Password",
        "oldPassword": "Old PassWord",
        "oldPwdMsg": "Please Enter Old Password"
    },
    "rules": {
        "mail": "Please Input The Email Address",
        "nickname": "Please Enter User Nickname",
        "phone": "Please Enter The Phone Number",
        "truemail": "Please Input The Correct Email Address",
        "truephone": "Please Enter The Correct Phone Number"
    },
    "user": {
        "createTime": "Created Date",
        "dept": "Department",
        "email": "User Mail",
        "man": "Man",
        "mobile": "Phone Number",
        "nickname": "Nick Name",
        "posts": "Position",
        "roles": "Own Role",
        "sex": "Sex",
        "title": "Personal Information",
        "username": "User Name",
        "woman": "Woman",
        "normalText": "Get SMS code",
    },
    "home": {
        "CorporateInformation": 'Corporate Information',
        'AccountInformation': 'Account Information',
        'BidOrder': 'BidOrder',
        "dashboard": "Home",
    },
    "companyInfo": {
        "Companyname": 'Company Name',
        "Contact": 'Contact'
    }
}




// WEBPACK FOOTER //
// ./src/i18n/config/en.js